import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ShapeChannelsIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/shape-channels"><g id="Icon"><path d="M10.6628 9.29862C11.294 8.17926 12.906 8.17926 13.5372 9.29862L15.2591 12.352C15.8794 13.4519 15.0846 14.8125 13.8219 14.8125H10.3781C9.11536 14.8125 8.32062 13.4519 8.94089 12.352L10.6628 9.29862Z" stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" /><path d="M12 3C7.03 3 3 7.03 3 12C3 13.3639 3.31347 14.661 3.85872 15.8207C4.09212 16.3171 4.17452 16.8786 4.02356 17.406L3.49 19.27C3.27 20.02 3.97 20.72 4.73 20.51L6.58771 19.9782C7.11876 19.8262 7.68418 19.9112 8.18369 20.147C9.34223 20.694 10.6379 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3Z" stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ShapeChannelsIcon;